/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @author Satyaki Bose
 * @file assignmentSettingsConstants.js
 * Assignment settings OR-specific constants.
 */

import {
  ASSIGNMENT_AVAILABILITY,
  GRADEBOOK_DISPLAY_MODE
} from '@aet/components';

export const SCORE_TYPE_API = {
  RAW_POINTS: 'RawPoints',
  WEIGHTED_POINTS: 'WeightedPoints'
};

export const AVAILABILITY_DAYS_BY_UI_VALUE = {
  [ASSIGNMENT_AVAILABILITY.IMMEDIATE]: 0,
  [ASSIGNMENT_AVAILABILITY.FOUR_WEEKS_BEFORE]: 28,
  [ASSIGNMENT_AVAILABILITY.TWO_WEEKS_BEFORE]: 14,
  [ASSIGNMENT_AVAILABILITY.ONE_WEEK_BEFORE]: 7
};

export const UI_VALUE_BY_AVAILABILITY_DAYS = Object.entries(AVAILABILITY_DAYS_BY_UI_VALUE)
  .reduce((accumulator, [uiValue, days]) => ({
    ...accumulator,
    [days]: uiValue
  }), {});

export const SCORE_TYPE_ALIASES = {
  [GRADEBOOK_DISPLAY_MODE.RAW_SCORE]: SCORE_TYPE_API.RAW_POINTS,
  [GRADEBOOK_DISPLAY_MODE.EQUAL_WEIGHTING]: SCORE_TYPE_API.WEIGHTED_POINTS
};

export const ASSIGNMENT_SETTINGS_ANALYTICS = {
  SCORING_METHOD: {
    EQUAL_WEIGHTING: 'equal_weighting',
    RAW_SCORE: 'raw_score'
  },
  CUSTOM_FIELD: {
    MODIFIED_SETTINGS: 'modified_settings',
    SCORING_METHOD: 'scoring_method',
    EQUAL_WEIGHTING_BASE_VALUE: 'equal_weighting_base_value',
    ASSIGNMENT_AVAILABILITY: 'assignment_availability',
    LATE_WORK_PENALTY_PCT: 'late_work_penalty_pct',
    LATE_WORK_PENALTY_WINDOW: 'late_work_penalty_window',
    DEFAULT_DUE_TIME: 'default_due_time',
    COURSE_TIME_ZONE: 'default_time_zone',
    ALLOW_LATE_WORK: 'allow_late_work',
    LATE_WORK_CUSTOM_DATE: 'late_work_custom_date'
  },
  LATE_WORK_DEADLINE_LABEL: {
    ONE_WEEK: '1 week',
    TWO_WEEKS: '2 weeks',
    COURSE_END: 'course end date',
    CUSTOM: 'custom date'
  }
};
